import { useMemo } from 'react';
import type { GenericItem } from '../types';

interface UseFormattedDataProps {
  data: GenericItem[];
}

export const useFormattedData = ({ data }: UseFormattedDataProps) => {
  return useMemo(() => {
    if (!Array.isArray(data)) {
      return [];
    }

    return data.map((item) => {
      const newItem = { ...item };
      Object.keys(newItem).forEach((key) => {
        const value = newItem[key];
        if (value === null || value === undefined) {
          newItem[key] = '';
        } else if (typeof value === 'object') {
          newItem[key] = JSON.stringify(value);
        } else if (typeof value === 'boolean') {
          newItem[key] = value ? 'Yes' : 'No';
        }
      });
      return newItem;
    });
  }, [data]);
};
